import { Component, Input } from '@angular/core';

/**
 * Etiqueta pequeña del estado de una cuenta frente a CrediTotal. Recibe la cuenta tal como la devuelve
 * GET /api/domiciliacion-ct/cliente/:code. Sin cuenta o con estado NO_APLICA no muestra nada.
 */
@Component({
  selector: 'app-estado-ct-badge',
  template: `<span *ngIf="info" class="ct-badge" [ngClass]="info.clase" [title]="titulo">{{ info.texto }}</span>`,
  styles: [`
    .ct-badge { display: inline-block; padding: 0 .4rem; border-radius: 9999px; border: 1px solid; font-size: 10px;
      font-weight: 600; line-height: 1.1rem; white-space: nowrap; background: transparent; }
    .ct-pendiente { color: #b45309; border-color: #fcd34d; }
    .ct-aceptada { color: #047857; border-color: #6ee7b7; }
    .ct-lista { color: #0f766e; border-color: #5eead4; }
    .ct-cobrando { color: #065f46; border-color: #059669; }
  `]
})
export class EstadoCtBadgeComponent {
  @Input() cuenta: any = null;

  private static readonly MAPA: { [k: string]: { texto: string; clase: string } } = {
    PENDIENTE: { texto: 'Pendiente T&C CrediTotal', clase: 'ct-pendiente' },
    ACEPTADA: { texto: 'T&C CrediTotal aceptados', clase: 'ct-aceptada' },
    LISTA_PARA_CT: { texto: 'Lista para CrediTotal', clase: 'ct-lista' },
    COBRANDO_CT: { texto: 'Cobrando con CrediTotal', clase: 'ct-cobrando' }
  };

  get info(): { texto: string; clase: string } | null {
    return EstadoCtBadgeComponent.MAPA[this.cuenta?.estado] || null;
  }

  get titulo(): string {
    const partes: string[] = [];
    if (this.cuenta?.aceptada_at) {
      const d = new Date(this.cuenta.aceptada_at);
      if (!isNaN(d.getTime())) partes.push(`Aceptados el ${d.toLocaleDateString('es-VE')}`);
    }
    if (this.cuenta?.terms_version) partes.push(`versión del texto: ${this.cuenta.terms_version}`);
    return partes.join(' · ') || (this.info?.texto || '');
  }
}
